import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { AvatarModule } from '../../avatar/avatar.module';
import { BadgeModule } from '../../badge/badge.module';
import { MessageCellComponent } from './message-cell.component';

@NgModule({
  declarations: [MessageCellComponent],
  exports: [MessageCellComponent],
  imports: [CommonModule, BadgeModule, AvatarModule, NgxBootstrapIconsModule],
})
export class MessageCellModule {}
